
    <div class="day-month-picker-header">
       <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon fontSet="fal" fontIcon="fa-long-arrow-left"></mat-icon>
      </button>
      <span class="day-month-picker-header-label">{{periodLabel}}</span>
      <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
      </button>
    </div>
  